import React, { memo } from "react";
import FilterTable from "./FilterTable";
import { TableSearch } from "./TableSearch";
import useTableCtx from "../tableContext/useTableCtx";
import TableDatePicker from "./TableDatePicker";
import TableOrder from "./TableOrder";

const TableHeaderCategories = memo(
  ({
    showActionButtons = true,
    showSearchForCategories = true,
  }: {
    showActionButtons?: boolean;
    showSearchForCategories?: boolean;
  }) => {
    const { tableHeader: tableHeaderCategories } = useTableCtx()!;

    const withSearchOrFilter = tableHeaderCategories.some(
      ({ withSearch, withFilter, withDatePicker }) =>
        withSearch || withFilter || withDatePicker,
    );

    return (
      <thead>
        {showSearchForCategories && withSearchOrFilter && (
          <tr className="bg-surface-subtle text-base text-muted [&_th]:py-3 [&_th]:font-semibold">
            {tableHeaderCategories.map(
              (
                {
                  value,
                  minW,
                  maxW,
                  withSearch,
                  withFilter,
                  withDatePicker,
                  filterDefaultIdx,
                },
                idx,
                categories,
              ) => (
                <th
                  key={value}
                  style={{
                    minWidth: withFilter?.length
                      ? Math.max(minW ?? 130, 180)
                      : withDatePicker
                      ? Math.max(minW ?? 130, 160)
                      : minW ?? 130,
                    maxWidth: maxW,
                  }}
                  className={`${
                    idx === 0
                      ? "pl-3 rounded-l-control"
                      : idx === categories.length - 1
                      ? "pr-3 rounded-r-control"
                      : ""
                  }`}>
                  {withSearch && (
                    <TableSearch value={value} withSearch={withSearch} />
                  )}
                  {withFilter && withFilter.length && (
                    <FilterTable
                      value={value}
                      withFilter={withFilter}
                      filterDefaultIdx={filterDefaultIdx}
                    />
                  )}
                  {withDatePicker && (
                    <TableDatePicker
                      value={value}
                      withDatePicker={withDatePicker}
                    />
                  )}
                </th>
              ),
            )}
            {showActionButtons && (
              <th className="min-w-[150px] rounded-r-control text-right"></th>
            )}
          </tr>
        )}
        <tr style={{ height: 10 }} />
        <tr className="bg-surface-subtle text-base text-muted [&_th]:py-3 [&_th]:font-semibold">
          {tableHeaderCategories.map(
            (
              { label, value, minW, maxW, width, withOrder },
              idx,
              categories,
            ) => (
              <th
                key={value}
                style={{ minWidth: minW ?? 130, maxWidth: maxW, width }}
                className={`${
                  idx === 0
                    ? "pl-3 rounded-l-control"
                    : idx === categories.length - 1
                    ? "pr-3 rounded-r-control"
                    : ""
                }`}>
                <TableOrder label={label} value={value} withOrder={withOrder} />
              </th>
            ),
          )}
          {showActionButtons && (
            <th
              scope="col"
              className="min-w-[150px] rounded-r-control text-right">
              Actiuni
            </th>
          )}
        </tr>
      </thead>
    );
  },
);

export default TableHeaderCategories;
